export const NOT_FOUND_LOCATION_CODE = 404;
